const Singleton = require('components/abstract/Singleton');
const Flash = require("services/Flash");

class FlashSingleton extends Singleton {

    renderSingletonContainer() {
        return (<Flash ref={this.extend} />);
    }

}

module.exports = new FlashSingleton;
